var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin":"-1rem","padding":"1rem"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('img',{attrs:{"src":_vm.src,"alt":"menu"}})])}
var staticRenderFns = []

export { render, staticRenderFns }